/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-15 11:28:22
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
export interface IResponse {
  code: number;
  data: any;
}

export interface IRequest {
  key: string;
  [propName: string]: any;
}

export interface ICallback {
  (data?: any): void;
}

export interface IListeners {
  [propName: string]: Array<ICallback>;
}

export interface IBridge {
  registerHandler(handlerName: string, handler: ICallback): void;
  callHandler: (
    handlerName: string,
    data?: any,
    responseCallback?: (data: IResponse) => void,
  ) => void;
}

interface IThirdApp {
  schemeUrl?: string;
  marketUrl?: string;
  packName?: string;
  params?: { [key: string]: [value: unknown] };
}

/**
 * 0 DidBecomeActive: - app已经切换到active状态后需要执行的操作
 * 1 WillResignActive: - app将要从前台切换到后台时需要执行的操作
 * 2 DidEnterBackground: - app已经进入后台后需要执行的操作
 * 3 WillEnterForeground: - app将要从后台切换到前台需要执行的操作，但app还不是active状态
 * 4 WillTerminate: - app将要结束时需要执行的操作
 */
export enum EAppChangeStatus {
  DidBecomeActive = 0,
  WillResignActive = 1,
  DidEnterBackground = 2,
  WillEnterForeground = 3,
  WillTerminate = 4,
}
interface ISystem {
  impactFeedback(): PromiseLike<IResponse>;
  copy(content: string): PromiseLike<IResponse>;
  openBrowser(v: string): PromiseLike<IResponse>;
  getSafeAreaInsets(): PromiseLike<IResponse>;
  openThirdApp(vs: IThirdApp): PromiseLike<IResponse>;
  offActiveChange(cb: (vs: { status: EAppChangeStatus }) => void): void;
  onActiveChange(cb: (vs: { status: EAppChangeStatus }) => void): void;
}

interface ICreateApplePay {
  productId: string;
  productName: string;
  userId: string;
  orderId: string;
  orderPrice: string | number;
  orderSourceType: number;
}

interface IPayment {
  createApplePay(vs: ICreateApplePay): PromiseLike<IResponse>;
}

interface IWebView {
  close(): PromiseLike<IResponse>;
}

export interface JSBridge {
  system: ISystem;
  payment: IPayment;
  webView: IWebView;
}
